import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { makeRepositories, makeWebClock, makeWebSecureStorage, useFakes } from "./composition.js";
import { createRootStores } from "./app/rootStores.js";
import { AppProvider } from "./app/AppContext.js";
import { SessionDepsProvider } from "./app/sessionDeps.js";
import { seedDemo } from "./dev/seedDemo.js";
import { App } from "./App.js";

// Composition wiring: build the backend (real or fake by env) and the platform
// capabilities once. Root stores (auth, theme) are built up front; the session-scoped
// stores are built from `repos` + `clock` inside the signed-in subtree.
const repos = makeRepositories();
const clock = makeWebClock();
const stores = createRootStores({ repos, storage: makeWebSecureStorage() });

// In offline/fake mode, populate a demo trip + sign in so the app opens populated.
if (useFakes) void seedDemo(repos);

const root = document.getElementById("root");
if (!root) throw new Error("No #root element");

createRoot(root).render(
  <StrictMode>
    <AppProvider stores={stores}>
      <SessionDepsProvider
        deps={{
          repos,
          clock,
          applyTemplateSyncPlan: repos.applyTemplateSyncPlan,
          applyCopyPlan: repos.applyCopyPlan,
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionDepsProvider>
    </AppProvider>
  </StrictMode>,
);
